var React = require('react');

function FlagBw (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.724H8.828A8.829 8.829 0 010 414.896V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.792a8.83 8.83 0 01-8.829 8.828z","fill":"#82afff","key":0}),React.createElement("path",{"fill":"#464655","d":"M0 229.52h512v52.965H0z","key":1}),React.createElement("g",{"fill":"#f5f5f5","key":2},React.createElement("path",{"d":"M0 211.86h512v17.655H0zM0 282.48h512v17.655H0z"}))]);
}

FlagBw.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagBw;

FlagBw.default = FlagBw;
